var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({on:{"mouseover":function($event){_vm.isHovered = true},"mouseleave":function($event){_vm.isHovered = false}}},_vm.$listeners),[_c('icon',{attrs:{"filled":_vm.shouldFill,"name":_vm.name,"color":_vm.color}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }